module.exports = __webpack_public_path__ + "static/media/NPL.4c014c2a.png";